import { render, staticRenderFns } from "./item-details.vue?vue&type=template&id=4311950a&scoped=true&"
import script from "./item-details.vue?vue&type=script&lang=js&"
export * from "./item-details.vue?vue&type=script&lang=js&"
import style0 from "./item-details.vue?vue&type=style&index=0&id=4311950a&prod&lang=css&"
import style1 from "./item-details.vue?vue&type=style&index=1&id=4311950a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311950a",
  null
  
)

export default component.exports